import { api } from ".";

export interface AuditUser {
  Id: number;
  EmailAddress: string;
}

export interface AuditTable {
  EntityName: string;
}

export interface IAuditFilter {
  UserIds: number[];
  EntityNames: string[];
}

export class AuditFilter implements IAuditFilter{
  UserIds: number[];
  EntityNames: string[];

  constructor(auditFilter: IAuditFilter) {
    this.UserIds = auditFilter.UserIds;
    this.EntityNames = auditFilter.EntityNames;
  }

  canFilter = (): boolean => {
    return this.UserIds.length > 0 || this.EntityNames.length > 0;
  }
}

export interface AuditRecord {
  Id: number;
  EventType: string;
  EntityName: string;
  ExternalId: number;
  Payload: string;
  DateUtc: Date;
  EmailAddress: string;
  UserId: number;
}

const auditUrlV1 = "/v1/Audits";

export const getAuditUsers = async () => {
  const response = await api.get<AuditUser[]>(`${auditUrlV1}/Users`);
  return response?.data;
};

export const getAuditTables = async () => {
  const response = await api.get<AuditTable[]>(`${auditUrlV1}/Tables`);
  return response?.data;
};

export const getAuditRecords = async (tableName: string, externalId: number) => {
  const response = await api.get<AuditRecord[]>(`${auditUrlV1}/${tableName}/id/${externalId}`);
  return response?.data;
}

export const filterAuditRecords = async (filters: AuditFilter) => {
  var params = new URLSearchParams();

  filters.UserIds.forEach(id => {
    params.append("UserIds", id.toString());  
  })

  filters.EntityNames.forEach(name => {
    params.append("EntityNames", name);  
  })

  var request = {
    params: params
  };

  const response = await api.get<AuditRecord[]>(`${auditUrlV1}`, request);
  return response?.data;
};